import { Component, OnInit, ViewChild } from '@angular/core';
import { IonMenu, LoadingController, NavController } from '@ionic/angular';
import { ConfirmController } from 'src/app/share/controllers/confirm.controller';
import { dataCustom, dataset, pageTitle, typeEvent } from 'src/app/share/enum/enum';
import { AuthService } from 'src/app/share/services/auth.service';
import { NotificationsService } from 'src/app/share/services/notifications.service';
import { ParametersService } from 'src/app/share/services/parameters.service';
import { ProfileService } from 'src/app/share/services/profile.service';
import { Util } from 'src/app/share/util/util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  @ViewChild('menu') menu?: IonMenu;

  //para el menu del hallowen
  hasHalloween: boolean = false;

  get appVersion() {
    return environment.mapache.version;
  }

  get notificationsCount() {
    return this.notificationsService.count;
  }

  get name() {
    return this.profileService.name;
  }
  get picture() {
    return this.profileService.picture;
  }

  constructor(
    private loadingController: LoadingController,
    private notificationsService: NotificationsService,
    private authService: AuthService,
    private profileService: ProfileService,
    private confirmController: ConfirmController,
    private util: Util,
    private navCtrl: NavController,
    private parameterService: ParametersService,
  ) { }

  ngOnInit() {

    //suscribimos al menu de hallowen
    this.parameterService.getHalloweenMenu$().subscribe(flag => {
      this.hasHalloween = flag;
    });

  }

  async logout() {
    const loading = await this.loadingController.create();
    await loading.present();
    await this.profileService.logout();
    await this.authService.logout();
    await loading.dismiss();

    this.menu?.close(true);

    this.navCtrl.navigateForward('/session/select-user', { animated: false, replaceUrl: true });
  }

  async confirmLogout() {
    this.util.eventTagAnalytics(dataCustom.empty, pageTitle.menu, typeEvent.optLogout, dataset.notifications);

    await this.confirmController.createAndPresent({
      icon: 'logout-icon',
      message: '¿Quieres cerrar esta sesión ahora?',
      confirm: {
        handler: async () => {
          await this.logout();
        },
      },
      cancel: {
        hide: false,
      }
    });
  }

  async openProfile() {
    this.util.eventTagAnalytics(dataCustom.empty, pageTitle.menu, typeEvent.optProfile, dataset.notifications);

    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/profile', { animated: false, replaceUrl: true });
    }, 700);
  }

  async openAddresses() {
    this.util.eventTagAnalytics(dataCustom.empty, pageTitle.menu, typeEvent.optAaddresses, dataset.notifications);

    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/addresses', { animated: false, replaceUrl: true });
    }, 700);
  }

  async openOrdersHistory() {
    this.util.eventTagAnalytics(dataCustom.empty, pageTitle.menu, typeEvent.optHistory, dataset.notifications);

    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/orders-history', { animated: false, replaceUrl: true });
    }, 700);
  }

  async openNotifications() {
    this.util.eventTagAnalytics(dataCustom.empty, pageTitle.menu, typeEvent.optNotify, dataset.notifications);

    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/notifications', { animated: false, replaceUrl: true });
    }, 700);
  }

  async openHelp() {
    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/help', { animated: false, replaceUrl: true });
    }, 700);
  }

  /**Para abrir el chat ia */
  async openChat() {
    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/chat', { animated: false, replaceUrl: true });
    }, 700);
  }

  openQuestions() {
    console.log("abriendo preguntas");
    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/hallowen-questions', { animated: false, replaceUrl: true });
    }, 700);
  }

  openPetRecord() {
    this.menu?.close(true);
    setTimeout(() => {
      this.navCtrl.navigateForward('/record', { animated: false, replaceUrl: true });
    }, 700);
  }

}
